import { Dialog, DialogTrigger } from "@/Components/ui/dialog";
import { Stage } from "@/types/productTypes";
import { useState } from "react";
import { useAdminStore } from "../../../../store/useAdminStore";
import { ImageConfigDialog } from "./ImageConfigDialog";
import {
   GenericEditor,
   CustomFieldConfig,
} from "@/Components/GenericEditor/GenericEditor";
import { stageConfig } from "@/configs/editorConfigs";
import { useUpdateStage } from "@/hooks/useStages";

type StageEditorProps = {
   stage: Stage;
};

export default function StageEditor({ stage }: StageEditorProps) {
   const adminStore = useAdminStore();
   const { mutate: updateStage } = useUpdateStage();
   const [isDialogOpen, setDialogOpen] = useState(false);
   const onStageChange = (field: keyof Stage, value: any) => {
      if (!adminStore.selectedProductId || !adminStore.selectedStageId) {
         return;
      }
      console.log("Updating stage:", field, value);
      updateStage({
         productId: adminStore.selectedProductId,
         stageId: adminStore.selectedStageId,
         patch: { [field]: value },
      });
   };

   const customConfig: CustomFieldConfig<Stage>[] = [
      {
         key: "imageConfig",
         label: "Image Config",
         type: "custom",
         render: () => (
            <div className="flex items-center w-full pt-2">
               <div className="space-y-4 w-72">
                  <div>
                     {stage.optionPair?.name ? (
                        <div className="flex items-center justify-between bg-gray-100 p-3 rounded-md mb-2">
                           <span className="text-sm w-32 text-gray-700 font-medium">
                              Current Config: {stage.optionPair.name}
                           </span>
                           <Dialog>
                              <DialogTrigger asChild>
                                 <button
                                    onClick={() => setDialogOpen(true)}
                                    className="px-4 py-2 text-sm text-blue-600 border border-blue-500 rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                 >
                                    Change Config
                                 </button>
                              </DialogTrigger>
                              {isDialogOpen && (
                                 <ImageConfigDialog
                                    currentStage={stage}
                                    onClose={() => setDialogOpen(false)}
                                 />
                              )}
                           </Dialog>
                        </div>
                     ) : (
                        <>
                           <div className="text-sm text-gray-500 italic mb-2">
                              No config selected.
                           </div>
                           <Dialog>
                              <DialogTrigger asChild>
                                 <button
                                    onClick={() => setDialogOpen(true)}
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 bg-white text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                 >
                                    Add Image Config
                                 </button>
                              </DialogTrigger>
                              {isDialogOpen && (
                                 <ImageConfigDialog
                                    currentStage={stage}
                                    onClose={() => setDialogOpen(false)}
                                 />
                              )}
                           </Dialog>
                        </>
                     )}
                  </div>
               </div>
            </div>
         ),
      },
   ];

   return (
      <div className="flex flex-row w-full h-full">
         <GenericEditor
            item={stage}
            config={stageConfig}
            customConfig={customConfig}
            onChange={onStageChange}
            title="Edit Stage"
         />
      </div>
   );
}
